<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:16:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 14:35:15
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\add\index.vue
-->
<template>
  <div>
    <!-- hasBtn('delete-data-strategy') -->
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-data-strategy')"
                       :show_del="false"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <v-tabs v-model="tab"
            grow
            background-color="#eeeef0"
            @change="tabchange"
            color='primary'
            dark>
      <v-tab v-for="(item,index) in stepList"
             class="text-capitalize"
             :key="index">
        {{ item.name}}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <columnTabs :readonly='readonly'
                    @updateSuccess='updateSuccess'
                    :baseInfo='params'
                    @success='submit'
                    @lastStep='lastStep'
                    :loading='loading'></columnTabs>
      </v-tab-item>

      <v-tab-item>
        <base-info @success='success'
                   @updateSuccess='updateSuccess'
                   :disabled='readonly'
                   :loading='loading'
                   @cancel='cancel'></base-info>
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
import { listData, delData } from '@/service/api/data-access-strategy'
import { required } from 'vuelidate/lib/validators'
import baseInfo from '../modules/baseInfo'
import columnTabs from '../modules/columnTabs'
export default {
  components: { baseInfo, columnTabs },
  props: {},
  data () {
    return {
      tab: 0,
      params: {},
      obj: {},
      loading: false,
      readonly: true
    };
  },
  validations: {},
  computed: {
    stepList () {
      return [
        { name: this.$t('label_data_strategy') },
        { name: this.$t('label_Basic_information') },
      ]
    }
  },
  beforeDestroy () {
    this.$store.commit('setTab', '')
  },
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_data_strategy'
          this.$store.commit('set_page_title', 'label_edit_data_strategy')
        }
        else {
          this.$route.meta.title = 'label_view_data_strategy'
          this.$store.commit('set_page_title', 'label_view_data_strategy')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
    this.tab = this.$store.state.tab
    this.$store.commit('setTab', this.tab)
  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion')
      }).then(res => {
        delData({
          org_level_uuid: this.$store.state.uuid
        }).then(res => {
          this.$router.push({
            name: 'data-access-strategy',
            params: {
              type: 'del'
            }
          })
          this.$Message({ text: this.$t('message_The_deletion_was_successful') })
        })
      }).catch(err => { })
    },
    success (val) { // 下一步
      this.step = 2
      this.params = val
    },
    cancel () { // 取消
      // this.$myConfirm({ content: this.$t('message_Confirm_the_cancellation_of_the_edit') })
      //   .then(() => {
      //     this.$router.go(-1)
      //   }).catch(() => { })
    },
    submit () {  // 提交

    },
    lastStep () {  //上一步
      this.step = 1
    },
    tabchange () {
      this.$store.commit('setTab', this.tab)
    },
    updateSuccess () {
      this.readonly = true
      this.$store.commit('set_iconstatus', this.readonly)
    }
  }
}
</script>

<style scoped>
</style>
